import '../App.css';
import '../style.css';
import '../font.css';
import {AnimationOnScroll} from 'react-animation-on-scroll';
import './style_works.css';
import { useLanguage } from '../contexts/LanguageContext';

export function WorkTextSection(props: {
    title?: React.ReactNode; 
    bigTitle? : boolean;
    description? : React.ReactNode;
    isWhiteText? : boolean;
    subDescription? : React.ReactNode;
    }) {
    const { language } = useLanguage();

    // Work(1~16) 페이지에서는 자동 번역을 사용하지 않고,
    // 언어 토글에 따라 description(영문)과 subDescription(국문)의 위치만 교체한다.
    const displayDescription = language === 'ko' ? props.subDescription : props.description;
    const displaySubDescription = language === 'ko' ? props.description : props.subDescription;

    return (
        <>
        <AnimationOnScroll animateIn="animate__fadeInUp" animateOnce={true} offset={10}>
            <div className={'textsection'}>
                {props.title && <div className={`work-text-title ${props.bigTitle? 'bigTitle' :''}`} style={{
                        color: props.isWhiteText ? 'var(--color-bg-base)' : 'var(--color-text-primary)',
                        fontSize: "24px",
                        fontStyle: "normal",
                        fontWeight: "700",
                        lineHeight: "140%"
                    }}>
                    {props.title}
                </div>}
                <div className='textsection-sub'>
                    {(props.description || props.subDescription) && <div className="work-text-description" style={{
                        color: props.isWhiteText ? 'var(--color-border-default)' : 'var(--color-text-secondary)',
                        fontSize: "20px",
                        fontStyle: "normal",
                        fontWeight: "400",
                        lineHeight: "151.8%",
                        // display: "inline-block"
                        // margin:"0px 0px 60px 0px"
                    }}>
                        {displayDescription}
                    </div>}
                    {(props.subDescription || props.description) && <div className="work-text-subdescription" style={{
                        color: 'var(--color-text-muted)',
                        fontSize: "13px",
                        fontStyle: "normal",
                        fontWeight: "400",
                        lineHeight: "151.8%",
                        maxWidth: "800px"
                        // margin:"0px 0px 60px 0px"
                    }}>
                        {displaySubDescription}
                    </div>}
                </div>
            </div>
        </AnimationOnScroll>
        </>
      )
}
